export default "__VITE_ASSET__D3_yJJfR__"